<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        Add Organization Map Data
      </div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="OrganizationDataForm">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group required" aria-required="true">
            <label class="sub-header-drpdown pb-2">Name</label>
            <div class="services-form">
              <input
                formControlName="name"
                type="text"
                maxlength="50"
                placeholder="Name"
                (blur)="checkNameExists()"
              />
              <label>Name</label>
              <div
                *ngIf="submitted && OrganizationDataForm.controls['name'].invalid"
                class="input-error"
              >
                Name is required
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="sub-header-drpdown pb-2">PIQET Material</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #material
              [items]="materialList"
              [searchable]="false"
              bindLabel="description"
              formControlName="materialName"
              [searchFn]="commonInputSearchDes"
              placeholder="PIQET Material"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="material.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label class="sub-header-drpdown pb-2">PIQET Conversion</label>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #conversion
              [items]="conversionList"
              [searchable]="false"
              bindLabel="name"
              formControlName="conversionName"
              [searchFn]="commonInputSearch"
              placeholder="PIQET Conversion"
              groupBy="childItems"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="conversion.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item?.name }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                  {{ item?.name }}
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <!-- Add validation message for material/conversion requirement -->
      <div *ngIf="hasValidationError" class="validation-error">
        Please select either PIQET Material or PIQET Conversion
      </div>

      <!-- Duplicate error message -->
      <div *ngIf="duplicateError" class="input-error">
        {{ duplicateError }}
      </div>
    </form>
  </div>

  <div class="mt-2">
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onAddRecord()">Add</button>
  </div>

  <!-- Table to display records -->
  <div class="mt-4" *ngIf="organizationDataRecords.length > 0">
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Material</th>
          <th>Conversion</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of organizationDataRecords">
          <td>{{ record.name }}</td>
          <td>{{ record.materialName?.description || '-' }}</td>
          <td>{{ record.conversionName?.name || '-' }}</td>
          <td>
            <button class="inlineActionButton" (click)="onDelete(record)">
              <span class="textDrpInline"
                ><img width="14.78" height="15.04" src="./assets/icons/inlineDelete.svg"
              /></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="modal-footer extraPadding">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      [disabled]="!organizationDataRecords.length"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
